import { Progress } from './ui/progress';
import { Loader2 } from 'lucide-react';

const UploadProgress = ({ progress, message = 'Uploading...' }) => {
  return (
    <div className="space-y-2" data-testid="upload-progress">
      <div className="flex items-center justify-between text-sm">
        <span className="flex items-center gap-2 text-slate-600">
          <Loader2 className="w-4 h-4 animate-spin" />
          {message}
        </span>
        <span className="font-mono text-slate-700 font-medium">{progress}%</span>
      </div>
      <Progress value={progress} className="h-2" />
      {progress === 100 && (
        <p className="text-xs text-slate-500">Processing file on server...</p>
      )}
    </div>
  );
};

export default UploadProgress;
